import { Component } from '@angular/core';
const Swal = require('sweetalert2');
import { NotificationsService } from '../../../../shared/services/Notifications.service';

@Component({
  selector: 'app-enviar',
  templateUrl: './enviar.component.html',
  styleUrls: ['./enviar.component.scss']
})
export class EnviarComponent {

  public Notificaciones = [
    { value: "1", label: "VENCIMIENTOS DE LICENCIAS DE CONDUCIR" },
   // { value: "2", label: "VENCIMIENTOS DE DOCUMENTOS DE VEHICULOS" },
  ];

  public tipoSeleccionado: string = "1"; // valor por defecto
  cargando: boolean = false;

  constructor(private notificationsService: NotificationsService) {}

  sendNotificaciones() {
    this.cargando = true;
    this.notificationsService.enviarNotificaciones().subscribe({
      next: (res) => {
        // Mostrar mensaje con SweetAlert
        Swal.fire({
          icon: 'info',
          title: 'Notificaciones enviadas',
          text: `Cantidad enviadas: ${res.enviados}`,
          confirmButtonText: 'Aceptar',
        });
        this.cargando = false;
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al enviar',
          text: err.message,
          confirmButtonText: 'Cerrar',
        });
        this.cargando = false;
      }
    });
  }
}
